import type { App } from 'vue'
// @ts-expect-error - no default export
import Vue3EasyDataTable from 'vue3-easy-data-table'

export function installTable(app: App<Element>) {
  app.component('EasyDataTable', Vue3EasyDataTable)
}
